import {ChangeDetectionStrategy, Component, Inject, ViewChild} from '@angular/core';
import {SIDE_NAV_DATA, SideNavRef} from 'shared/sidenav';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DevicesClient, EditMode, Jig, UpsertJig} from 'shared';
import {firstValueFrom} from 'rxjs';
import {NgrxBusy, withBusy} from "ngrx-busy";

@Component({
  selector: 'app-jig-form',
  templateUrl: './jig-form.component.html',
  styleUrls: ['./jig-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JigFormComponent {
  @ViewChild(NgrxBusy, {static: true}) busy: NgrxBusy;

  EditMode = EditMode;
  Number = Number;

  mode: EditMode;
  form: UntypedFormGroup;

  constructor(
    private readonly sideNavRef: SideNavRef<JigFormComponent>,
    private formBuilder: UntypedFormBuilder,
    private devicesClient: DevicesClient,
    @Inject(SIDE_NAV_DATA) public jig?: Jig
  ) {
    this.mode = jig ? EditMode.Edit : EditMode.Create;

    this.form = this.mode === EditMode.Create
      ? this.formBuilder.group({
        id: [null, Validators.required],
        short_id: [null],
        settings: [null]
      })
      : this.formBuilder.group({
        id: [jig.id],
        short_id: [jig.short_id ? jig.short_id : ''],
        settings: [jig.settings ? jig.settings : '']
      });
  }

  async save(): Promise<void> {
    if (!this.form.valid) return;
    try {
      const command = this.form.getRawValue();
      await firstValueFrom(this.devicesClient.upsertJig(new UpsertJig(command)).pipe(withBusy(() => this.busy)));
      this.sideNavRef.close(true);
    } catch (error) {
      console.error(error)
      this.form.setErrors(error);
    }
  }
}
